import { render, staticRenderFns } from "./companyNews.vue?vue&type=template&id=71500b8a&scoped=true"
import script from "./companyNews.vue?vue&type=script&lang=js"
export * from "./companyNews.vue?vue&type=script&lang=js"
import style0 from "./companyNews.vue?vue&type=style&index=0&id=71500b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71500b8a",
  null
  
)

export default component.exports